<div class="EFMap" role="region" [attr.aria-label]="'experience-finder.a11y.map-region' | locTranslate">
    <div class="EFMap-Buttons my-3 px-2">
        @if (hasDirections) {
            <div class="me-2 btn-group" role="group" [attr.aria-label]="'experience-finder.a11y.map-region' | locTranslate">
                <button type="button" class="btn {{travelMode == 'walking' ? 'btn-primary' : 'btn-link bg-white'}}" (click)="setTravelMode('walking')" [attr.aria-pressed]="travelMode == 'walking'" [attr.aria-label]="'experience-finder.a11y.map-walking' | locTranslate">
                    <i class="fa-regular fa-walking" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn {{travelMode == 'bicycling' ? 'btn-primary' : 'btn-link bg-white'}}" (click)="setTravelMode('bicycling')" [attr.aria-pressed]="travelMode == 'bicycling'" [attr.aria-label]="'experience-finder.a11y.map-bicycling' | locTranslate">
                    <i class="fa-regular fa-biking" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn {{travelMode == 'driving' ? 'btn-primary' : 'btn-link bg-white'}}" (click)="setTravelMode('driving')" [attr.aria-pressed]="travelMode == 'driving'" [attr.aria-label]="'experience-finder.a11y.map-driving' | locTranslate">
                    <i class="fa-regular fa-car" aria-hidden="true"></i>
                </button>
            </div>
        }
        <div class="me-2 btn-group">
            <button type="button" class="btn {{satelliteMap ? 'btn-primary' : 'btn-link bg-white'}}" (click)="toggleSatelliteMap()" [attr.aria-pressed]="satelliteMap" [attr.aria-label]="'experience-finder.a11y.map-satellite' | locTranslate">
                <i class="fa-regular fa-satellite" aria-hidden="true"></i>
            </button>
        </div>
        <div>
            @if (resultNum == 0) {
                <button type="button" class="btn btn-link bg-white shadow-sm text-muted" disabled>
                    {{ 'experience-finder.general.no-results' | locTranslate }}
                </button>
            }
            @if (resultNum > 0) {
                <button type="button" class="btn btn-link bg-white shadow-sm" (click)="centerMap(true)" [attr.aria-label]="'experience-finder.a11y.center-map' | locTranslate">
                    <span>{{ 'experience-finder.general.num-results' | locTranslate:'num':resultNum }}</span>
                    <i class="fa-regular fa-dot-circle" aria-hidden="true"></i>
                </button>
            }
        </div>
    </div>
    <div class="EFMap-Inner GoogleMaps" #gmapsElement role="presentation"></div>
</div>
